module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin"
  }, [_c('ol', {
    staticClass: "c-breadcrumb"
  }, _vm._l((_vm.breadcrumb), function(bread, index) {
    return _c('li', {
      key: bread,
      staticClass: "c-breadcrumb__item"
    }, [(bread.hasLink && index < _vm.breadcrumb.length - 1) ? _c('router-link', {
      staticClass: "c-breadcrumb__link",
      attrs: {
        "to": bread.path
      }
    }, [_vm._v("\n        " + _vm._s(bread.label) + "\n      ")]) : (!bread.hasLink && index < _vm.breadcrumb.length - 1) ? _c('span', {
      staticClass: "c-breadcrumb__link"
    }, [_vm._v("\n        " + _vm._s(bread.label) + "\n      ")]) : _c('span', [_vm._v("\n        " + _vm._s(bread.label) + "\n      ")])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea4bfa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Breadcrumb.vue
// module id = 3150
// module chunks = 0